import React, { Component } from 'react'
import { Table } from 'antd'
import { app } from '../../app'
import common from '../review/common'
import { getInsuranceLog } from './insure_api'
import utils from '../../utils'

class IEditList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data_loading: true,
            dataList: [],
            page: 1,
            total: 0,
        }
    }

    async componentDidMount() {
        this._isMounted = true
        await this.dataSource(1)
    }

    /**
     * 数据列表
     * @param page
     * @returns {Promise<void>}
     */
    dataSource = async (page) => {
        const state = { data_loading: true, dataList: [] }
        if (page) {
            state.page = page
        } else {
            page = this.state.page
        }
        await this.setData(state)
        const { data, total } = await getInsuranceLog({ page, id: this.props.id })
        if (page === this.state.page) {
            await this.setData({
                total,
                dataList: utils.addArrayKey(data),
                data_loading: false,
            })
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    render() {
        let { data_loading, dataList, page, total } = this.state,
            columns = [
                {
                    title: '保险名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '10%'
                },
                {
                    title: '保险单号',
                    dataIndex: 'cntr_no',
                    key: 'cntr_no',
                    width: '10%'
                },
                {
                    title: '保险类型',
                    dataIndex: 'type_title',
                    key: 'type_title',
                    width: '10%'
                },
                {
                    title: '承保公司',
                    dataIndex: 'company',
                    key: 'company',
                    width: '10%'
                },
                {
                    title: '保险有效期',
                    dataIndex: 'expiry',
                    key: 'expiry',
                    width: '10%',
                },
                {
                    title: '投保人',
                    dataIndex: 'hldr_name',
                    key: 'hldr_name',
                    width: '10%'
                },
                {
                    title: '被保人',
                    dataIndex: 'ipsn_name',
                    key: 'ipsn_name',
                    width: '10%'
                },
                {
                    title: '管理员审核',
                    dataIndex: 'team_header_audit',
                    key: 'team_header_audit',
                    width: '15%',
                    render: (audit, { team_header_name, team_header_time, detail, buy_type }) => {
                        if (buy_type === '2') {
                            return common.tableStatus(String(audit), team_header_name, team_header_time, detail)
                        } else {
                            return (<span>无需审核</span>)
                        }
                    }
                },
                // {
                //     title: '省管审核',
                //     dataIndex: 'admin_audit',
                //     key: 'admin_audit', 
                //     width: '15%',
                //     render: (audit, { admin_name, admin_time, detail, buy_type }) => {
                //         if (buy_type === '2') {
                //             return common.tableStatus(String(audit), admin_name, admin_time, detail)
                //         } else {
                //             return (<span>无需审核</span>)
                //         }
                //     }
                // }
            ]
        // （内资）有限公司
        return (
            <div style={{ height: '80vh', overflowY: 'auto' }}>
                <Table
                    columns={columns}
                    dataSource={dataList}
                    size="small"
                    bordered
                    loading={data_loading}
                    locale={app.tbLocale(data_loading)}
                    className="qubian-table table-odd-even-row"
                    pagination={{
                        current: page,
                        total: total,
                        pageSize: 20,
                        showTotal: (t) => `总共${t}条.`,
                        onChange: this.dataSource
                    }}
                />
            </div>
        )
    }
}

export default IEditList



// WEBPACK FOOTER //
// ./src/routes/insure/IEditList.jsx